<div class="ts-chart qa-chart" #chartDiv></div>
